// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import asyncMergeSort from 'async-merge-sort'

const sortData = (arr, { asc, col }, callback) => {
  const sorter = (a, b, cb) => {
    const av = a[col]
    const bv = b[col]

    if (asc) {
      return cb(null, (av >= bv) ? 1 : -1)
    } else {
      return cb(null, (av <= bv) ? 1 : -1)
    }
  }

  return asyncMergeSort(arr, sorter, callback)
}

export default sortData
